import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import {
  Alert,
  Form,
  Table,
  Modal,
  Dropdown,
  DropdownButton
} from 'react-bootstrap';
import _get from 'lodash/get';
import _size from 'lodash/size';
import _isEmpty from 'lodash/isEmpty';
import SearchBar from 'material-ui-search-bar';
import Accordion from '@material-ui/core/Accordion';
import Snackbar from '@material-ui/core/Snackbar';
import MailIcon from '@material-ui/icons/Mail';
import MuiAlert from '@material-ui/lab/Alert';
import Tooltip from '@material-ui/core/Tooltip';
import { Tab, Tabs, TabPanel, TabList } from 'react-tabs';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import InboxIcon from '@material-ui/icons/Inbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@material-ui/core';
import ReactPlayer from 'react-player';
import FormGroup from '@material-ui/core/FormGroup';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import { purple, red } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  Favorite,
  Share,
  ExpandMore,
  MoreVert,
  ExpandLess
} from '@material-ui/icons';

// import ShareIcon from '@material-ui/icons/Share';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import FavoriteIcon from '@material-ui/icons/FavoriteIcon';
// import MoreVertIcon from '@material-ui/icons/MoreVert';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';
import { faPlus, faGrinBeam } from '@fortawesome/free-solid-svg-icons';
import { Container, Wrapper, HomeButtons } from '../../styles/HomeStyles';
import Header from '../header/Header';
import { FormWrapper, Label } from '../../styles/LoginStyles';
import Dimage from '../../assets/3D-printing.jpg';
// import { TabPanel, a11yProps } from '../instructor/Home';
import {
  DashboardWrapper,
  ButtonWrapper,
  ContentWrapper,
  TextWrapper,
  ControlButtonWrapper,
  ActionButtons,
  UserLabel,
  TableWrapper,
  NormalText,
  CardSubText
} from '../../styles/DashboardStyles';
import { SwitchButton, InputWrapper, Row } from '../../styles/InstructorStyles';
import { config } from '../../config';
import { styles } from '../../styles/TabStyles';

export function Toast(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  tabTextColor: {
    backgroundColor: '#4287cc'
  },
  media: {
    height: 0,
    paddingTop: '56.25%' // 16:9
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  form: {
    '& .MuiTextField-root': {
      margin: theme.spacing(10),
      width: '25ch'
    }
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  avatar: {
    backgroundColor: red[500]
  }
}));

export default function StudentDashboard() {
  const history = useHistory();

  const classes = useStyles();

  const [expanded, setExpanded] = React.useState(false);
  const [tabValue, setValue] = useState(0);
  const [isEdit, setEdit] = useState(null);

  const handleExpandClick = panel => (event, isExpanded) => {
    setExpanded(panel);
  };

  // const handleChange = panel => (event, isExpanded) => {
  //   setExpanded(isExpanded ? panel : false);
  // };

  const handleValueChange = (event, newValue) => {
    setValue(newValue);
  };

  const [tabIndex, setTabIndex] = useState(0);
  const [approvedAdmins, setApprovedAdmins] = useState([]);
  const [currentCourse, setCurrentCourse] = useState(null);
  const [currentCourseName, setCurrentCourseName] = useState(null);
  const [displayNote, setDisplayNote] = useState(false);
  const [note, setNote] = useState('');
  const [currentLecture, setCurrentLecture] = useState(null);
  const [currentSection, setCurrentSection] = useState(null);
  const [currentCourseObj, setCurrentCourseObj] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentCategories, setCurrentCategories] = useState([]);
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [currentLectures, setCurrentLectures] = useState([]);

  const [lectureNotes, setLectureNotes] = useState([]);

  const [category, setCategory] = useState(null);
  const [course, setCourse] = useState(null);
  const [section, setSection] = useState(null);
  const [video, setVideo] = useState(null);
  const [lectureName, setLecture] = useState('');
  const [lectureLink, setLectureLink] = useState('');
  const [lectureDescription, setLectureDescription] = useState('');

  const [supportDescription, setSupportDescription] = useState('');
  const [supportEmail, setSupportEmail] = useState('');
  const [supportName, setSupportName] = useState('');

  const [categoryInput, setCategoryInput] = useState('');
  const [courseInput, setCourseInput] = useState('');
  const [sectionInput, setSectionInput] = useState('');

  const [categoryid, setCategoryId] = useState(null);
  const [courseid, setCourseId] = useState(null);
  const [sectionid, setSectionId] = useState(null);

  const [showDelete, setShowDelete] = useState(false);

  const [addNew, setAddNew] = useState(false);
  const [status, setStatus] = useState(false);
  const [videoModalShow, setVideoModalShow] = useState(false);
  const [successModalShow, setSuccessModalShow] = useState(false);
  const [displayLectures, setDisplayLectures] = useState(true);

  const [alertSuccess, setAlertSuccess] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filtered, setFiltered] = useState([]);
  const { t } = useTranslation();

  const showLectures = () => {
    setDisplayLectures(true);
  };

  const showStats = () => {
    setDisplayLectures(false);
  };

  const handleAccordionChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    const uid = reactLocalStorage.get('userId');
    axios
      .all([
        axios.get(`${config.API_URL}course/categories/all`),
        axios.get(`${config.API_URL}course/student/${uid}/enrolled`),
        axios.get(`${config.API_URL}course/student/allcourses/${uid}`)
      ])
      .then(
        axios.spread((obj1, obj2, obj3) => {
          console.log(obj2, 'obj2');
          setCurrentCategories(_get(obj1, 'data.data', []));
          setEnrolledCourses(_get(obj2, 'data.data', []));
          setAllCourses(_get(obj3, 'data.data.decision', []));
        })
      )
      .catch(err => {
        console.log(err, 'enrolled error');
      });
  }, [currentCourse, status]);

  useEffect(() => {
    const uid = localStorage.getItem('userId');
    axios
      .get(`${config.API_URL}course/student/${uid}/course/${currentCourse}`)
      .then(response => {
        console.log(response, 'course response');
        setCurrentCourseObj(_get(response, 'data.data', []));
        // setStatus('You have successfully added the category');
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  }, [currentCourse, status]);

  useEffect(() => {
    const uid = localStorage.getItem('userId');
    console.log(uid, 'currentocourse', currentCourse);
    axios
      .get(
        `${config.API_URL}course/student/${uid}/lec/${_get(
          currentLecture,
          'lectureid',
          0
        )}/notes`
      )
      .then(response => {
        setLectureNotes(_get(response, 'data.data', []));
        console.log(lectureNotes, 'NOTES RESPONSE');
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  }, [currentLecture, alertSuccess, status]);

  const addCategory = () => {
    setCategoryInput('');
    const uid = localStorage.getItem('userId');
    const categoryData = {
      userid: uid,
      name: categoryInput === '' ? category.name : categoryInput,
      description: 'Sample Description'
    };
    axios
      .post(`${config.API_URL}course/instructor/addCategory`, categoryData)
      .then(response => {
        console.log(response, 'response');
        setStatus('You have successfully added the category');
        setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const editNote = noteId => {
    const uid = localStorage.getItem('userId');
    const noteData = {
      description: note
    };
    axios
      .put(
        `${config.API_URL}course/student/${uid}/lec/${_get(
          currentLecture,
          'lectureid',
          0
        )}/note/${noteId}`,
        noteData
      )
      .then(response => {
        console.log(response, 'response');
        setStatus('Note edited successfully');
        setAlertSuccess(true);
        setEdit(null);
        setNote('');
        setDisplayNote(false);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const deleteNote = noteId => {
    const uid = localStorage.getItem('userId');
    axios
      .delete(`${config.API_URL}course/student/notes/delete/${noteId}}`)
      .then(response => {
        console.log(response, 'response');
        setStatus('Note deleted successfully');
        setAlertSuccess(true);
        setDisplayNote(false);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const addNewNote = () => {
    setDisplayNote(false);
    setLectureNotes('');
    const noteData = {
      userid: localStorage.getItem('userId'),
      lectureid: currentLecture.lectureid,
      description: note
    };
    axios
      .post(`${config.API_URL}course/student/mycourse/lecture/notes`, noteData)
      .then(response => {
        console.log(response, 'response');
        setNote('');
        setStatus('Note Added Successfully');
        setAlertSuccess(true);
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const enrollCourse = index => {
    const uid = localStorage.getItem('userId');
    const courseData = {
      userid: uid,
      courseid: index.courseid
    };
    axios
      .post(`${config.API_URL}course/student/enroll`, courseData)
      .then(response => {
        console.log(response, 'response');
        setStatus(`You have successfully enrolled in ${index.name}`);
        setAlertSuccess(true);
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const unenrollCourse = index => {
    const uid = localStorage.getItem('userId');
    axios
      .delete(
        `${config.API_URL}course/delete/student/${uid}/course/${index.courseid}`
      )
      .then(response => {
        console.log(response, 'response');
        setShowDelete(false);
        setStatus(`You have successfully unenrolled from ${index.name}`);
        setAlertSuccess(true);
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const categoryAccordionView = () => {
    return (
      <Grid container justify="center">
        <div className={classes.accordion}>
          {currentCategories.map((index, key) => {
            return (
              <Accordion
                expanded={expanded === `panel${key}`}
                onChange={handleAccordionChange(`panel${key}`)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography className={classes.heading}>
                    {index.name}
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    {index.description}
                  </Typography>
                </AccordionSummary>
                {_size(index.course) === 0 ? (
                  <AccordionDetails>
                    <NormalText>{t('Thiscategoryhasnocourses')}</NormalText>
                  </AccordionDetails>
                ) : (
                  <React.Fragment>
                    {index.course.map(i => {
                      return (
                        <AccordionDetails>
                          <p
                            onClick={() => {
                              setCurrentCourse(i.courseid);
                              setCurrentCourseName(i.name);
                            }}
                          >
                            <a href="#">{i.name}</a>
                          </p>
                        </AccordionDetails>
                      );
                    })}
                  </React.Fragment>
                )}
              </Accordion>
            );
          })}
        </div>
      </Grid>
    );
  };

  const renderLecture = (lecture, enrolled) => {
    console.log(currentSection, 'currsec');
    return (
      <center>
        <h2>{lecture.name}</h2>
        {currentSection.key > 0 && (
          <>
            {/* <p>Previous Lesson</p> */}
            <Tooltip title="Previous Lecture">
              <SkipPreviousIcon
                style={{ fontSize: 70 }}
                onClick={() => {
                  setCurrentLecture(
                    currentSection.section.lecture[currentSection.key - 1]
                  );
                  setCurrentSection({
                    section: currentSection.section,
                    key: currentSection.key - 1
                  });
                }}
              />
            </Tooltip>
          </>
        )}
        {currentSection.key < _size(currentSection.section.lecture) - 1 && (
          <>
            <Tooltip title="Next Lecture">
              <SkipNextIcon
                style={{ fontSize: 70 }}
                onClick={() => {
                  setCurrentLecture(
                    currentSection.section.lecture[currentSection.key + 1]
                  );
                  setCurrentSection({
                    section: currentSection.section,
                    key: currentSection.key + 1
                  });
                }}
              />
            </Tooltip>
            {/* <p>Next Lesson</p> */}
          </>
        )}
        <NormalText>{lecture.description}</NormalText>
        {enrolled && (
          <React.Fragment>
            <ReactPlayer
              width={1200}
              height={700}
              controls={true}
              url={lecture.link}
            />
            <NormalText>{lecture.description}</NormalText>
            {!displayNote && (
              <HomeButtons
                onClick={() => {
                  setDisplayNote(true);
                  setNote('');
                  setEdit(null);
                }}
              >
                {t('AddNote')}
              </HomeButtons>
            )}
            {displayNote && (
              <React.Fragment>
                <div>
                  <TextareaAutosize
                    aria-label="minimum height"
                    rowsMin={3}
                    style={{ width: 400, height: 150 }}
                    value={note}
                    onChange={e => setNote(e.target.value)}
                    placeholder={t('NoteDescription')}
                  />
                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => addNewNote()}
                      disabled={note === ''}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </React.Fragment>
            )}
            <h3 style={{ paddingTop: 20 }}>{t('LectureNotes')}</h3>
            {lectureNotes &&
              lectureNotes.map((index, key) => {
                return (
                  <React.Fragment>
                    <center>
                      <div style={{ width: '60%' }}>
                        <List component="nav" aria-label="main mailbox folders">
                          <ListItem button>
                            <ListItemIcon>
                              <SpeakerNotesIcon />
                            </ListItemIcon>
                            <ListItemText
                              primary={index.description}
                              secondary={moment(index.createdAt).format(
                                'MMM DD, hh:mm A'
                              )}
                            />
                            <ListItemIcon
                              onClick={() => {
                                setEdit(key);
                                setDisplayNote(false);
                                setNote(index.description);
                              }}
                            >
                              <EditIcon />
                            </ListItemIcon>
                            <ListItemIcon>
                              <DeleteIcon
                                onClick={() => deleteNote(index.studentnotesid)}
                              />
                            </ListItemIcon>
                          </ListItem>
                        </List>
                        <Divider />
                        {isEdit === key && (
                          <React.Fragment>
                            <TextareaAutosize
                              aria-label="minimum height"
                              rowsMin={3}
                              style={{ width: 400, height: 150 }}
                              value={note}
                              onChange={e => setNote(e.target.value)}
                              placeholder="Note Description"
                            />
                            <div>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() => editNote(index.studentnotesid)}
                                disabled={note === ''}
                              >
                                Submit
                              </Button>
                              <Button
                                variant="contained"
                                style={{ marginLeft: 5 }}
                                color="secondary"
                                onClick={() => setEdit(null)}
                              >
                                Cancel
                              </Button>
                            </div>
                          </React.Fragment>
                        )}
                      </div>
                    </center>
                  </React.Fragment>
                );
              })}
          </React.Fragment>
        )}
      </center>
    );
  };

  const courseAccordionView = () => {
    const sec = currentCourseObj[0] && currentCourseObj[0].section;
    const name = currentCourseObj[0] && currentCourseObj[0].name;
    const description = _get(currentCourseObj[0], 'description', '');
    const enrolled = _get(currentCourseObj[0], 'enrolled', 0);
    const courseType = _get(currentCourseObj[0], 'coursetype', '');
    return (
      <Grid container justify="center">
        <div className={classes.accordion}>
          <center>
            <h3>{currentCourseName}</h3>
            <p style={{ width: '60%' }}>{description}</p>
            {_size(sec) > 0 && (
              <>
                {enrolled === 0 ? (
                  <Button
                    onClick={() => enrollCourse(currentCourseObj[0])}
                    variant="contained"
                    color="primary"
                    style={{ marginBottom: 20 }}
                  >
                    ENROLL
                  </Button>
                ) : (
                  <Button
                    onClick={() => setShowDelete(true)}
                    variant="contained"
                    color="primary"
                    style={{ marginBottom: 20 }}
                  >
                    UNENROLL
                  </Button>
                )}
              </>
            )}
          </center>
          {courseType === 'free' ? (
            <NormalText>{t('Thisisafreecourse')}</NormalText>
          ) : (
            <NormalText>{t('Thisisapaidcourse')}</NormalText>
          )}
          {_size(sec) === 0 ? (
            <NormalText>
              {t('ThiscoursehasnocontentPleasecheckbacklater')}
            </NormalText>
          ) : (
            <React.Fragment>
              {sec.map((index, key) => {
                return (
                  <center>
                    <Accordion
                      expanded={expanded === `panel${key}`}
                      style={{ width: '70%' }}
                      onChange={handleAccordionChange(`panel${key}`)}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Typography className={classes.heading}>
                          <b>{index.name}</b>
                        </Typography>
                        <Typography className={classes.secondaryHeading}>
                          <b>{index.description}</b>
                        </Typography>
                      </AccordionSummary>
                      {_size(index.lecture) === 0 ? (
                        <AccordionDetails>
                          {t('Thissectionhasnolectures')}
                        </AccordionDetails>
                      ) : (
                        <React.Fragment>
                          {index.lecture.map(i => {
                            return (
                              <AccordionDetails>
                                <Typography className={classes.heading}>
                                  {i.name}
                                </Typography>
                                <Typography
                                  className={classes.secondaryHeading}
                                >
                                  {i.description}
                                </Typography>
                              </AccordionDetails>
                            );
                          })}
                        </React.Fragment>
                      )}
                    </Accordion>
                  </center>
                );
              })}
            </React.Fragment>
          )}
        </div>
      </Grid>
    );
  };

  const addCourse = () => {
    setCourseInput('');
    const uid = localStorage.getItem('userId');
    const courseData = {
      userid: uid,
      name: courseInput === '' ? course.name : courseInput,
      description: 'Sample Description',
      categoryid: category.categoryid
    };
    axios
      .post(`${config.API_URL}course/instructor/addCourse`, courseData)
      .then(response => {
        console.log(response, 'response');
        setStatus('You have successfully added the course');
        setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const addSection = () => {
    setSectionInput('');
    const uid = localStorage.getItem('userId');
    const sectionData = {
      userid: uid,
      name: sectionInput === '' ? section.name : sectionInput,
      description: 'Sample Description',
      courseid: course.courseid
    };
    axios
      .post(`${config.API_URL}course/instructor/addSection`, sectionData)
      .then(response => {
        console.log(response, 'response');
        setStatus('You have successfully added the section');
        setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const sendSupport = sectionId => {
    setSupportDescription('');
    setSupportEmail('');
    setSupportName('');
    const uid = localStorage.getItem('userId');
    const supportData = {
      email: supportEmail,
      name: supportName,
      message: supportDescription
    };
    axios
      .post(`${config.API_URL}general/support`, supportData)
      .then(response => {
        console.log(response, 'response');
        setStatus(
          `You have successfully contacted support! We will get back to you shortly`
        );
        setAlertSuccess(true);
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const addLecture = () => {
    setLecture('');
    setLectureLink('');
    setLectureDescription('');
    const uid = localStorage.getItem('userId');
    const lectureData = {
      userid: uid,
      name: lectureName,
      description: lectureDescription,
      sectionid: section.sectionid,
      link: lectureLink
    };
    axios
      .post(`${config.API_URL}course/instructor/addLecture`, lectureData)
      .then(response => {
        console.log(response, 'response');
        setStatus('You have successfully added the lecture');
        setSuccessModalShow(true);
        setAddNew(false);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const showVideo = index => {
    setVideo(index);
    setVideoModalShow(true);
  };

  const VideoModal = props => {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {video && video.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ReactPlayer style={{ width: 800 }} url={video && video.link} />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const SuccessModal = props => {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Success!</Modal.Title>
          <FontAwesomeIcon size="2x" icon={faGrinBeam} />
        </Modal.Header>
        <Modal.Body>
          <p>{status}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const CourseCard = (index, showEnrolled) => {
    return (
      <React.Fragment>
        <Grid item xs={4}>
          <Card className={classes.root}>
            <CardHeader
              avatar={
                <Avatar aria-label="recipe" className={classes.avatar}>
                  {_get(index, 'name', '').charAt(0)}
                </Avatar>
              }
              action={
                <IconButton
                  onClick={() => {
                    setStatus(
                      `Email of the instructor is ${_get(
                        index,
                        'user.email',
                        ''
                      )}`
                    );
                    setAlertSuccess(true);
                  }}
                  aria-label="settings"
                >
                  <MailIcon />
                </IconButton>
              }
              title={_get(index, 'name', '')}
              subheader={_get(index, 'user.name', '')}
            />
            <CardMedia
              className={classes.media}
              image={Dimage}
              title="Paella dish"
            />
            <CardContent>
              <Typography variant="body2" color="textSecondary" component="p">
                {_get(index, 'description', '')}
              </Typography>
              {index.coursetype === 'free' ? (
                <CardSubText>{t('FreeCourse')}</CardSubText>
              ) : (
                <CardSubText>{t('PaidCourse')}</CardSubText>
              )}
            </CardContent>

            <CardActions disableSpacing>
              {showEnrolled && (
                <Button
                  onClick={() => enrollCourse(index)}
                  variant="contained"
                  color="primary"
                >
                  {t('ENROLL')}
                </Button>
              )}
              {/* <IconButton aria-label="add to favorites">
                <Favorite />
              </IconButton>
              <IconButton aria-label="share">
                <Share />
              </IconButton> */}
              {!showEnrolled && expanded !== `panel${index.courseid}` && (
                <IconButton
                  // className={clsx(classes.expand, {
                  //   [classes.expandOpen]: expanded
                  // })}
                  onClick={handleExpandClick(`panel${index.courseid}`)}
                  aria-expanded={expanded}
                  aria-label="show more"
                >
                  <ExpandMore />
                </IconButton>
              )}
              {expanded === `panel${index.courseid}` && (
                <IconButton
                  // className={clsx(classes.expand, {
                  //   [classes.expandOpen]: expanded
                  // })}
                  onClick={handleExpandClick('panel')}
                  aria-expanded={expanded}
                  aria-label="show more"
                >
                  <ExpandLess />
                </IconButton>
              )}
              <NormalText>{t('Clicktoviewlectures')}</NormalText>
            </CardActions>
            <Collapse
              in={expanded === `panel${index.courseid}`}
              timeout="auto"
              unmountOnExit
            >
              {_get(index, 'section', []).map(i => {
                return (
                  <CardContent>
                    <Typography variant="h4" paragraph>
                      {_get(i, 'name', '')}
                    </Typography>
                    {_get(i, 'lecture', []).map((j, key) => {
                      return (
                        <>
                          <Typography paragraph>
                            {_get(j, 'name', '')}
                          </Typography>
                          {/* <p onClick={() => showVideo(j)}>
                            <a href="#">Watch Lecture</a>
                          </p> */}
                          <p
                            onClick={() => {
                              setCurrentLecture(j);
                              setCurrentSection({
                                section: i,
                                key
                              });
                            }}
                          >
                            <a href="#">{t('WatchLecture')}</a>
                          </p>
                        </>
                      );
                    })}
                  </CardContent>
                );
              })}
            </Collapse>
          </Card>
          {/* <Card style={{ width: '18rem' }}>
            <Card.Img
              variant="top"
              src={{
                url: 'https://i.ytimg.com/vi/cn591Vct9OU/maxresdefault.jpg'
              }}
            />
            <Card.Body>
              <Card.Title>{_get(index, 'name', '')}</Card.Title>
              <Card.Text>{_get(index, 'description', '')}</Card.Text>
              <Button variant="primary">View Lectures</Button>
            </Card.Body>
          </Card>{' '} */}
        </Grid>
      </React.Fragment>
    );
  };

  const renderEnrolledCourses = () => {
    let filteredArr = [];
    return (
      <TabPanel>
        <Typography align="center" variant="h4" paragraph>
          {t('EnrolledCourses')}
        </Typography>
        {currentLecture === null && (
          <center>
            <SearchBar
              value={searchText}
              style={{ width: '95%' }}
              onChange={res => {
                setSearchText(res);
                filteredArr = enrolledCourses.filter(i => {
                  return (
                    _get(i, 'course.name', '')
                      .toLowerCase()
                      .includes(searchText.toLowerCase()) ||
                    _get(i, 'course.description', '')
                      .toLowerCase()
                      .includes(searchText.toLowerCase()) ||
                    _get(i, 'course.user.name', '')
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  );
                });
                setFiltered(filteredArr);
              }}
              onRequestSearch={() => {
                filteredArr = enrolledCourses.filter(i => {
                  return i.course.name.includes(searchText);
                });
                setFiltered(filteredArr);
              }}
            />
          </center>
        )}
        {_size(enrolledCourses) === 0 && (
          <NormalText>
            {t('Actualmente no estás inscrito en ningún curso')}
          </NormalText>
        )}
        {currentLecture === null && (
          <div style={{ padding: 20 }}>
            <Grid container item xs={12} spacing={3}>
              {searchText === '' ? (
                <>
                  {enrolledCourses.map((index, key) => {
                    return <>{CourseCard(index.course, false)}</>;
                  })}
                </>
              ) : (
                <>
                  {filtered.map((index, key) => {
                    return <>{CourseCard(index.course, false)}</>;
                  })}
                </>
              )}
            </Grid>
          </div>
        )}
        {currentLecture !== null && (
          <center>
            <p
              onClick={() => {
                setCurrentLecture(null);
                setDisplayNote(false);
                setNote('');
                setEdit(null);
              }}
            >
              <a href="#">{t('GoBack')}</a>
            </p>
          </center>
        )}
        {currentLecture !== null && renderLecture(currentLecture, true)}
      </TabPanel>
    );
  };

  const renderAllCourses = () => {
    return (
      <TabPanel>
        {currentCourse !== null && currentLecture !== null && (
          <Typography align="center" variant="h4" paragraph>
            All Courses
          </Typography>
        )}
        {currentCourse !== null && currentLecture === null && (
          <center>
            <p
              onClick={() => {
                setCurrentCourse(null);
              }}
            >
              <a href="#">{t('GoBack')}</a>
            </p>
          </center>
        )}
        {currentLecture !== null && (
          <center>
            <p
              onClick={() => {
                setCurrentLecture(null);
              }}
            >
              <a href="#">{t('GoBacktoLectureList')}</a>
            </p>
          </center>
        )}
        {currentLecture === null && (
          <React.Fragment>
            {currentCourse === null
              ? categoryAccordionView()
              : courseAccordionView()}
          </React.Fragment>
        )}
        {currentLecture !== null && renderLecture(currentLecture, false)}
        {/* {_size(allCourses) === 0 && (
          <NormalText>There are currently no courses available</NormalText>
        )}
        <div style={{ padding: 20 }}>
          <Grid container item xs={12} spacing={3}>
            {allCourses.map((index, key) => {
              return <>{CourseCard(index, true)}</>;
            })}
          </Grid>
        </div> */}
      </TabPanel>
    );
  };

  const support = () => {
    return (
      <TabPanel>
        <center>
          <form className={classes.form} noValidate autoComplete="off">
            <div>
              <TextField
                required
                id="standard-required"
                label={t('Name')}
                value={supportName}
                error={supportName === ''}
                onKeyPress={event => {
                  if (event.key === 'Enter') {
                    sendSupport();
                  }
                }}
                errorText="Name is required"
                onChange={e => setSupportName(e.target.value)}
              />

              <TextField
                required
                id="standard-required"
                label={t('Email')}
                value={supportEmail}
                error={supportEmail === ''}
                onKeyPress={event => {
                  if (event.key === 'Enter') {
                    sendSupport();
                  }
                }}
                errorText="Email is required"
                onChange={e => setSupportEmail(e.target.value)}
              />
              <div>
                <TextareaAutosize
                  aria-label="minimum height"
                  rowsMin={3}
                  style={{ width: 400, height: 150 }}
                  value={supportDescription}
                  onKeyPress={event => {
                    if (event.key === 'Enter') {
                      sendSupport();
                    }
                  }}
                  onChange={e => setSupportDescription(e.target.value)}
                  placeholder={t('EnterSupportMessage')}
                />
              </div>
            </div>
            <Button
              onClick={() => sendSupport()}
              variant="contained"
              color="primary"
              disabled={
                supportEmail === '' ||
                supportName === '' ||
                supportDescription === ''
              }
            >
              {t('SEND')}
            </Button>
          </form>
        </center>
      </TabPanel>
    );
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertSuccess(false);
  };

  return (
    <Container>
      <DashboardWrapper>
        <Header setTabIndex={() => setTabIndex(0)} />
      </DashboardWrapper>
      <ContentWrapper>
        <Snackbar
          open={alertSuccess}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Toast onClose={handleClose} severity="success">
            {status}
          </Toast>
        </Snackbar>
        <Snackbar
          open={showDelete}
          autoHideDuration={3000}
          onClose={handleClose}
          message={`Are you sure you want to unenroll from the course "${_get(
            currentCourseObj[0],
            'name',
            ''
          )}"?`}
          action={
            <>
              <Button
                onClick={() => unenrollCourse(currentCourseObj[0])}
                color="inherit"
                size="small"
              >
                DELETE
              </Button>
              <Button
                onClick={() => setShowDelete(false)}
                color="inherit"
                size="small"
              >
                CANCEL
              </Button>
            </>
          }
        />
        <Tabs
          selectedIndex={tabIndex}
          onSelect={index => {
            setTabIndex(index);
            setCurrentLecture(null);
            setCurrentCourse(null);
          }}
          selectedTabClassName={classes.tabTextColor}
        >
          <TabList style={styles.tabList}>
            <Tab style={styles.tabs}>{t('ENROLLEDCOURSES')}</Tab>
            <Tab style={styles.tabs}>{t('ALLCOURSES')}</Tab>
            <Tab style={styles.tabs}>{t('CONTACTSUPPORT')}</Tab>
          </TabList>
          {/* <AppBar position="static">
          <Tabs
            style={{ backgroundColor: 'black' }}
            value={tabValue}
            onChange={handleValueChange}
            aria-label="simple tabs example"
          >
            <Tab label="Enrolled Courses" {...a11yProps(0)} />
            <Tab label="All Courses" {...a11yProps(1)} />
          </Tabs>
        </AppBar> */}
          {renderEnrolledCourses()}
          {renderAllCourses()}
          {support()}
        </Tabs>
        {/* {_size(currentLectures) > 0 && (
          <TableWrapper>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Lecture</th>
                  <th>Section</th>
                  <th>Course</th>
                  <th>Category</th>
                  <th>Description</th>
                  <th>Link</th>
                </tr>
              </thead>
              <tbody>
                {currentLectures.map((index, key) => {
                  return (
                    <>
                      <tr>
                        <td>{key + 1}</td>
                        <td>{_get(index, 'name', '')}</td>
                        <td>{_get(index, 'section.name', '')}</td>
                        <td>{_get(index, 'section.course.name', '')}</td>
                        <td>
                          {_get(index, 'section.course.category.name', '')}
                        </td>
                        <td>{_get(index, 'description', '')}</td>
                        <td>
                          <p onClick={() => showVideo(index)}>
                            <a href="#">Watch Lecture</a>
                          </p>
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </Table>
          </TableWrapper>
        )} */}
      </ContentWrapper>
      <VideoModal
        show={videoModalShow}
        onHide={() => setVideoModalShow(false)}
      />
      <SuccessModal
        show={successModalShow}
        onHide={() => setSuccessModalShow(false)}
      />
    </Container>
  );
}
